// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "./LoggerUtils.bs.js";
import * as PaymentConfirmTypes$OrcaPaymentPage from "../Types/PaymentConfirmTypes.bs.js";

function handleDDC(ddcData, iframeId, isPaymentSession, resolve, data, optLogger, paymentMethod) {
  var match = Core__Option.getOr(ddcData, PaymentConfirmTypes$OrcaPaymentPage.defaultDdcData);
  var iframeUrl = match.iframeUrl;
  LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "DDC initiated", "DDC_FLOW", paymentMethod, undefined);
  Utils$OrcaPaymentPage.messageParentWindow(undefined, [
        [
          "fullscreen",
          true
        ],
        [
          "param",
          "paymentloader"
        ],
        [
          "iframeId",
          iframeId
        ]
      ]);
  var errorType = "error";
  var errorMessage = "Something went wrong";
  var handleFailure = function () {
    Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
    if (!isPaymentSession) {
      Utils$OrcaPaymentPage.postFailedSubmitResponse(errorType, errorMessage);
    }
    var failedSubmitResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse(errorType, errorMessage);
    resolve(failedSubmitResponse);
  };
  if (iframeUrl === "") {
    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "DDC failed: empty iframe URL", "DDC_FLOW", paymentMethod, "ERROR");
    return handleFailure();
  }
  var timeoutIdRef = {
    contents: undefined
  };
  var messageHandlerRef = {
    contents: undefined
  };
  var iframeRef = {
    contents: undefined
  };
  var cleanup = function () {
    Core__Option.forEach(timeoutIdRef.contents, (function (prim) {
            clearTimeout(prim);
          }));
    Core__Option.forEach(messageHandlerRef.contents, (function (h) {
            window.removeEventListener("message", h);
          }));
    Core__Option.forEach(iframeRef.contents, (function (prim) {
            prim.remove();
          }));
    timeoutIdRef.contents = undefined;
    messageHandlerRef.contents = undefined;
    iframeRef.contents = undefined;
  };
  var handleMessage = function (ev) {
    try {
      var json = ev.data;
      var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
      if (!Core__Option.isSome(dict["next_action"])) {
        return ;
      }
      var nextAction = PaymentConfirmTypes$OrcaPaymentPage.getNextAction(dict, "next_action");
      var nextActionType = nextAction.type_;
      var redirectUrl = nextAction.postDdcRedirectUrl;
      var redirectMode = nextAction.redirectMode;
      cleanup();
      if (nextActionType === "redirect_to_url" && redirectUrl !== "") {
        LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "DDC completed successfully", "DDC_FLOW", paymentMethod, undefined);
        Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
        if (redirectMode === "if_required") {
          if (isPaymentSession) {
            return resolve(data);
          } else {
            return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                          "openurl_if_required",
                          redirectUrl
                        ]]);
          }
        }
        LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "Post DDC redirection", "REDIRECTING_USER", paymentMethod, "INFO");
        return Utils$OrcaPaymentPage.openUrl(redirectUrl);
      } else {
        LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "DDC failed: invalid next action type - " + nextActionType, "DDC_FLOW", paymentMethod, "ERROR");
        return handleFailure();
      }
    }
    catch (raw_exn){
      var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
      var err = JSON.stringify(exn);
      LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "DDC failed: message parse error - " + err, "DDC_FLOW", paymentMethod, "ERROR");
      cleanup();
      return handleFailure();
    }
  };
  messageHandlerRef.contents = handleMessage;
  window.addEventListener("message", handleMessage);
  var iframe = Utils$OrcaPaymentPage.makeHiddenIframe(document.body, iframeUrl, "ddc-iframe");
  iframeRef.contents = Caml_option.some(iframe);
  timeoutIdRef.contents = Caml_option.some(setTimeout((function () {
              LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "DDC timed out", "DDC_FLOW", paymentMethod, "ERROR");
              cleanup();
              handleFailure();
            }), match.timeoutMs));
}

export {
  handleDDC ,
}
/* Utils-OrcaPaymentPage Not a pure module */
